module.exports = __webpack_public_path__ + "img/IMG_9960.e920e669.jpg";